import { AlertOctagonIcon, EyeIcon, InfoIcon } from "lucide-react";
import { NotificationType, TNotification } from "../../types/Notifications";
import dayjs from "dayjs";
import { CONFIG } from "../../constants/config";

export const SidebarNotification = ({
  notification,
  onClick,
}: {
  notification: TNotification;
  onClick: () => void;
}) => {
  return (
    <div className="py-3">
      <div className="flex mb-2">
        <div className="mr-3 pt-1">
          {notification.type === NotificationType.ERROR ? (
            <AlertOctagonIcon
              className={`mt-3 h-5 w-5 ${
                notification.isRead ? "text-gray-600" : "text-red-700"
              }`}
            />
          ) : (
            <InfoIcon
              className={`mt-3 h-5 w-5 ${
                notification.isRead ? "text-gray-600" : "text-blue-500"
              }`}
            />
          )}
        </div>
        {/* <span className="text-xl">{notification.device.name}</span> */}
        <div className="mt-3 text-gray-900 font-bold">
          {notification.device.name}        <div className="mt-2 text-gray-900 text-sm font-bold">{notification.message}</div>
        </div>
      </div>
      {/* <div className="mb-mb-1 text-gray-900 font-bold">{notification.device.name} {notification.message}</div> */}
      <div className="text-sm ml-8 mb-3 text-gray-900">
        {notification.details}
      </div>
      <div className="mb-3 ml-8 text-xs font-semibold text-gray-700">
        <span className="mr-3">
          {/* Sent:{" "} */}
          {dayjs(notification.updated_at).format(
            CONFIG.STANDARD_DATETIME_FORMAT
          )}
          <br />
          {/* Created:{" "}
          {dayjs(notification.created_at).format(
            CONFIG.STANDARD_DATETIME_FORMAT
          )} */}
        </span>
        {/* <span className="bg-red-100 rounded-full px-2 py px-3 inline-flex text-sm leading-8">
            {device.location?.name || ""}
          </span> */}
      </div>
      <div
        className="text-blue-700 flex gap-3 cursor-pointer"
        onClick={onClick}
        title="View Device Detail Page"
      >
        {/* <EyeIcon /> */}
        <span className="ml-8 mb-3 text-sm font-semibold underline text-blue-700 hover:text-blue-800 cursor-pointer">
          View {notification.device.name}
        </span>
      </div>
    </div>
  );
};
